const bodyElement = document.querySelector('body')
const backdropElement = document.createElement('div')
backdropElement.classList.add('mobile-nav-backdrop')

export function hideNavBackdrop() {
  if (bodyElement.contains(backdropElement)) {
    bodyElement.removeChild(backdropElement)
  }
}

export function showNavBackdrop() {
  if (!bodyElement.contains(backdropElement)) {
    bodyElement.appendChild(backdropElement)
  }
}
